module.exports = __webpack_public_path__ + "img/project-14.5a360596.jpg";